import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { formatNumber, pathname } from '../../../../utils';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import { requestResponse } from '../Requests';
import { useHistory } from 'react-router';
import LoadingButton from '../../../lowLevel/LoadingButton';
import AdminFreeText from './AdminFreeText';

const useStyles = makeStyles((theme: any) => ({
  logo: { width: 70, marginBottom: '10px', marginTop: '40px' },
  topMargin: {
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },

  button: {
    fontSize: 'large',
    minWidth: 175,
  },
}));

export default function Approved({ request, showResponse, loading }) {
  const classes = useStyles();
  const history = useHistory();
  const isDiscountPaymentApproved =
    request.type === 'payment' && request.new_amount < 0;

  const onClick = async () => {
    await showResponse(requestResponse.complete);
  };

  const redirectToLine = () => {
    if (request.type === 'financing_application') {
      history.push(pathname.lines.url);
    } else {
      history.push(pathname.remittance.url);
    }
  };

  function renderApprovalWithoutDiscount() {
    return (
      <>
        <Typography variant="h5" className={classes.topMargin}>
          Great news!
        </Typography>
        <Typography variant="h6">
          Your requested changes have been applied to{' '}
          {request.type === 'payment' &&
            "your Funds Delivery Schedule, with no change to your Growth Plan's terms."}
          {request.type === 'financing_application' && (
            <span>
              the relevant Lines, with no change to your <br /> funds delivery
              terms or schedule.
            </span>
          )}
        </Typography>
        <Typography variant="h6" className={classes.bottomMargin}>
          You do not need to take any further action.
        </Typography>
      </>
    );
  }

  function renderApprovalWithDiscount() {
    return (
      <>
        <Typography variant="h5" className={classes.topMargin}>
          Great news!
        </Typography>
        <Typography variant="h6">
          Your requested changes have been applied to your Funds Delivery
          Schedule, with no change to your Growth Plan's terms. We are excited
          to let you know that we have deducted $
          {formatNumber(Math.abs(request.new_amount))} from your payback!
        </Typography>
        <Typography variant="h6" className={classes.bottomMargin}>
          You do not need to take any further action.
        </Typography>
      </>
    );
  }

  return (
    <DialogContent className={classes.root}>
      <img src={'./icons/edit.svg'} className={classes.logo} alt="edit logo" />
      {!isDiscountPaymentApproved && renderApprovalWithoutDiscount()}
      {isDiscountPaymentApproved && renderApprovalWithDiscount()}
      <AdminFreeText freeText={request?.admin_free_text} center={true} />
      <DialogActions>
        <LoadingButton
          variant="contained"
          className={classes.button}
          color="primary"
          onClick={onClick}
          loading={loading}
        >
          <b>Thanks</b>
        </LoadingButton>
      </DialogActions>
      <DialogActions>
        <Button className={classes.button} onClick={redirectToLine}>
          <b>I need to request more changes.</b>
        </Button>
      </DialogActions>
    </DialogContent>
  );
}
